import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Copy, Alert, Box, Optional } from '@honda-canada/design-system-react';
import DealerLocatorSubApp from '@honda-canada/react-subapp-dealer-locator/lib/components/DealerLocator';
import { DealerCard, DisclaimerUI, TitleComponent } from './shared';
import useGetDisclaimer from './hooks/useGetDisclaimer';
DealerLocatorSubApp.displayName = 'DealerLocatorSubApp';
const InventoryDealerCard = (props) => {
    const { t } = useTranslation();
    return React.createElement(DealerCard, { ctaLabel: t('Sub-apps.Dealers.seeInventoryButton'), ...props });
};
const Disclaimer = () => {
    const { t } = useTranslation();
    return React.createElement(DisclaimerUI, { disclaimer: t('Sub-apps.Dealers.dealersInventoryText') });
};
const DisclaimerForEV = ({ fields }) => {
    const disclaimer = useGetDisclaimer();
    const message = fields === null || fields === void 0 ? void 0 : fields.message;
    return (React.createElement(React.Fragment, null,
        React.createElement(DisclaimerUI, { disclaimer: disclaimer }),
        React.createElement(Optional, { when: message },
            React.createElement(Box, { px: ['s', 's', '0'], mb: "default", "data-testid": "cy-ev-model-alert" },
                React.createElement(Alert, { variant: "warning", iconSize: "large" },
                    React.createElement(Copy, { size: "extraSmall", fontFamily: "bold" }, message))))));
};
const DealerLocatorUI = ({ fields, alertMessage, isVehicleEV, ctaQueryString, componentName, pageTitle, }) => {
    const DisclaimerComponent = isVehicleEV ? DisclaimerForEV : Disclaimer;
    return (React.createElement(React.Fragment, null,
        React.createElement(Optional, { when: pageTitle },
            React.createElement(Helmet, null,
                React.createElement("title", null, pageTitle))),
        React.createElement(DealerLocatorSubApp, { componentName: "jss-dealer-locator", DealerCardComponent: InventoryDealerCard, SubAppTitleComponent: TitleComponent, DisclaimerComponent: DisclaimerComponent, 
            // TODO: move data props outside jss fields
            fields: { ...fields, message: alertMessage, isVehicleEV, ctaQueryString, componentName } })));
};
export default DealerLocatorUI;
